import React, {Component} from 'react';
import * as firebase from 'firebase';
import {Link} from 'react-router-dom';
import ReactLoading from 'react-loading';
import ADPost from '../component/ADPost';
import MetaTags from 'react-meta-tags';
import FacebookProvider, { Comments } from 'react-facebook';
import '../css/blog.css'
import {
  ShareButtons,
  generateShareIcon
} from 'react-share';

const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');

export default class AuthorityBlogs extends Component {
  constructor() {
    super();
    this.state = {
      blogTag: '',
      croppedImg: '',
      createDate: '',
      createTime: '',
      content: '',
      value: '',
      loading: true,
      blogBg: ''
    }
  }
  componentDidMount(blogName) {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      setTimeout(() => this.setState({ loading: false }), 2400);
        let theId = this.props.match.params.id;
        const blogsRef = firebase.database().ref('MedicalTeamPosts/').orderByChild('id').equalTo(theId);
        blogsRef.on('value', snap => {
          snap.forEach((child) => {
            this.setState({
              blogName: child.val().blogName,
              blogTag: child.val().blogTag,
              secondTag: child.val().secondTag,
              otherTag1: child.val().otherTag1,
              otherTag2: child.val().otherTag2,
              croppedImg: child.val().croppedImg,
              createTime: child.val().createTime,
              createDate: child.val().createDate,
              value: child.val().value,
              id: child.val().id,
              author: child.val().author,
              authorUrl: child.val().authorUrl,
              name: child.val().name,
              Authority: child.val().Authority,
              theAuthor: 'MedicalTeams/' + child.val().userId
            })
            
          })

        })
        
    })

  }

  render() {
    const { loading } = this.state;

    if(loading) {
      return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
    }

    return(
      <div className="container-fluid blogs">
       <div className="row">
        <MetaTags>
            <title>草學藥事 || {this.state.blogName}</title>
            <meta id="og-title" property="og:title" content={this.state.blogName} />
            <meta id="og-image" property="og:image" content={this.state.listPhoto} />
        </MetaTags>
        <article style={Jeyu.blogBg} className="Info">
         <sup>{this.state.createDate} / {this.state.createTime}</sup>
         <h1>{this.state.blogName}</h1>
         <div>
          <Link to={"/AuthorityTag/" + this.state.blogTag} target="_blank" style={{borderRadius: 40}}>{ this.state.blogTag }</Link>
           <Link to={"/AuthorityTags/" + this.state.secondTag} target="_blank" style={{borderRadius: 40}}>{ this.state.secondTag }</Link>
           <Link to={"/AuthorityTagsa/" + this.state.otherTag1} style={{display: this.state.otherTag1 ? 'inline-block' : 'none',borderRadius: 40}} target="_blank">{ this.state.otherTag1 }</Link>
           <Link to={"/AuthorityTagsb/" + this.state.otherTag2} style={{display: this.state.otherTag2 ? 'inline-block' : 'none',borderRadius: 40}} target="_blank">{ this.state.otherTag2 }</Link>
         </div>
         <article className="fbBox">

          <div className="Demo__some-network">
            <FacebookShareButton
              url={'https://herbalcure.com.tw/AuthorityBlogs/'+ this.state.id}
              quote={this.state.blogName}
              className="Demo__some-network__share-button">
              <FacebookIcon
                size={26}
                round />
           </FacebookShareButton>
          </div>
          <div className="Demo__some-network">
            <GooglePlusShareButton
              url={'https://herbalcure.com.tw/AuthorityBlogs/'+ this.state.id}
              className="Demo__some-network__share-button">
              <GooglePlusIcon
                size={26}
                round />
            </GooglePlusShareButton>
          </div>
         </article>
        </article>

        <div className="container">
         <div className="row" style={Jeyu.hasPadding}>
          <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
           <div style={Jeyu.hasMarginTop}>
              <a href={'https://herbalcure.com.tw/' + this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author">作者: {this.state.name} {this.state.Authority} </a>
              <a href={this.state.authorUrl} target="_blank" rel="noopener noreferrer" className="author" style={{display: this.state.author ? 'block' : 'none'}} >文章來源: {this.state.author}</a>
            </div>
           <article>
            <img src={this.state.croppedImg} alt={this.state.blogTag} style={{display: this.state.croppedImg ? 'block' : 'none'}} />
           </article>
           <article>
            <div dangerouslySetInnerHTML={{__html: this.state.value}} className="blogBox"></div>
           </article>
           <div style={{margin: '15px 0 0 0'}}>
           <FacebookProvider appId="442538242786461">
            <Comments href={'https://herbalcure.com.tw/Faqs/' + this.state.id} />
           </FacebookProvider>
           </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-1">
            <ADPost />
          </div>
         </div>
        </div>
       </div>
      </div>
    )
  }
}


const Jeyu = {
  loading: {
    margin: '20% auto',
    width: 77,
    height: '100vh'
  },
  blogBg: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '130px 20px 50px',
    textAlign: 'center'
  },
  hasPadding: {
    padding: '35px 0'
  },
  hasMarginTop: {
    marginBottom: 20
  },
  photoBox: {
    maxWidth: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/post/AuthorityBlogs.js